<template>
	<PageContainer title="Relatório Geral">
		<div v-if="user === 'admin' || idRole === 2" slot="header">
			<Button @handle:click="redirectToAdmin" text="Relatórios administrativos" color="secondary"
				:disabled="loadingAluno || loading">
				<FileChartOutline :size="18" />
			</Button>
		</div>

		<div class="d-flex justify-content-center" v-if="!loaded">
			<LoadingSpinner />
		</div>

		<template v-else>
			<Box space="medium" class="schema-container" v-if="idRole == 2">
				<span>Selecione uma auto escola para gerar os relatórios</span>

				<Select class="input" :options="schemaOptions" legend="Auto escola" placeholder="Selecione uma auto escola"
					:modelValue="schema" @update:modelValue="$event => (schema = $event)" :disabled="loadingAluno || loading" />
			</Box>

			<Box space="medium">
				<form @submit.prevent="handleSubmitAluno" class="form-container">
					<div class="form-container-row">
						<div class="form-radio">
							<span>Selecione qual relatório deseja emitir</span>

							<RadioButtons :options="alunoRadioOptions" name="relatorioAluno" :modelValue="relatorioAluno"
								@update:modelValue="$event => this.relatorioAluno = $event" />
						</div>
					</div>
					<div class="form-container-row">
						<Select class="input" :filtered="true" :options="alunos" legend="Aluno" placeholder="Digite o nome do aluno"
							:modelValue="aluno" @update:modelValue="$event => (this.aluno = $event)"
							:disabled="loadingAluno || loading || !schema" />

						<Button type="submit" text="Gerar relatório" color="primary" :disabled="loadingAluno || loading || !schema">
							<TrayArrowDown :size="18" />
						</Button>
					</div>
				</form>
			</Box>

			<Box space="medium">
				<form @submit.prevent="handleSubmitPeriod" class="form-container">
					<div class="form-container-row">
						<div class="form-radio">
							<span>Selecione qual relatório deseja emitir</span>

							<RadioButtons :options="periodoRadioOptions" name="relatorioPeriodo" :modelValue="relatorioPeriodo"
								@update:modelValue="$event => this.relatorioPeriodo = $event" />
						</div>
					</div>
					<div class="form-container-row">
						<Period class="input" legend="Período" :firstModelValue="dataIni" :secondModelValue="dataFim"
							@update:firstModelValue="$event => (this.dataIni = $event)"
							@update:secondModelValue="$event => (this.dataFim = $event)" :disabled="loading || !schema" />

						<Button type="submit" text="Gerar relatório" color="primary" :disabled="loading || !schema">
							<TrayArrowDown :size="18" />
						</Button>
					</div>
				</form>
			</Box>
		</template>
	</PageContainer>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import urlApiV2 from '../../router/urlApiV2'
import _export from '../../services/export'
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import LoadingSpinner from 'core/LoadingSpinner'
import RadioButtons from 'core/RadioButtons'
import Select from 'core/Select'
import Button from 'core/Button'
import Period from 'core/Period'
import TrayArrowDown from 'icons/TrayArrowDown'
import FileChartOutline from 'icons/FileChartOutline'

export default {
	name: 'relatorioGeral',
	components: {
		...spinners,
		TrayArrowDown,
		FileChartOutline,

		PageContainer,
		Box,
		LoadingSpinner,
		RadioButtons,
		Select,
		Button,
		Period,
	},
	data() {
		return {
			idRole: Number(localStorage.id_role),
			schema: null,
			alunoRadioOptions: [
				{ value: "aulasPorAluno", label: "Aulas por aluno" },
				{ value: "cargaHorariaPratica", label: "Carga horária prática" },
				{ value: "aulasPraticasPorAluno", label: "Aulas práticas por aluno" },
			],
			periodoRadioOptions: [
				{ value: "listaDeAlunos", label: "Lista de alunos" },
				{ value: "aulasPraticasRealizadas", label: "Aulas práticas realizadas" },
			],
			alunos: [],
			schemaOptions: [],
			relatorioAluno: 'aulasPorAluno',
			relatorioPeriodo: 'listaDeAlunos',
			user: '',
			aluno: null,
			dataIni: '',
			dataFim: '',
			loading: false,
			loadingAluno: false,
			loaded: false,
		}
	},
	async created() {
		const email = localStorage.email.split('@')
		this.user = email[0]

		if (this.idRole === 2) {
			await this.fetchCfcs()
		} else {
			this.schema = localStorage.schema

			await this.loadAlunos(this.schema)
		}

		this.loaded = true
	},
	methods: {
		async fetchCfcs() {
			await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
				.then((res) => {
					this.schemaOptions = res.body.dados.map(cfc => ({ value: cfc.tenant_schema, text: cfc.nome_fantasia }))
				})
				.catch((error) => {
					this.$toasted.show('Erro!' + error.body.mensagem, {
						position: 'top-right',
					})
				})
		},
		async loadAlunos(schema) {
			this.loadingAluno = true
			this.alunosOptions = []

			await this.$http.get(`${urlApiV2}/alunos/consultar/select/${schema}`)
				.then(response => {
					this.alunos = response.body.dados
				})
				.catch(err => {
					this.toast(err)
				})
				.finally(() => {
					this.loaded = true
					this.loadingAluno = false
				})
		},
		redirectToAdmin() {
			this.$router.push({ name: 'admin-relatorios' })
		},
		async handleSubmitAluno() {
			if (this.validateInputsAluno()) {
				switch (this.relatorioAluno) {
					case 'aulasPorAluno':
						await this.generateClassReportPerStudent()
						break
					case 'cargaHorariaPratica':
						await this.generatePracticalWorkloadReport()
						break
					case 'aulasPraticasPorAluno':
						await this.generatePracticalClassesReportPerStudent()
						break
					default:
						this.toast('Tipo do relatório é inválido.')
						break
				}
			}
		},
		validateInputsAluno() {
			if (!this.relatorioAluno || !this.aluno) {
				this.toast('Preencha todos os campos para gerar o relatório.')

				return false
			}

			return true
		},
		async generateClassReportPerStudent() {
			await this.reportRequest(`${urlApi}/alunos/relatorio-aulas-por-aluno/${this.aluno}?schema=${this.schema}`, 'dataPDF', 'relatorio-de-aulas-por-aluno')
		},
		async generatePracticalWorkloadReport() {
			await this.reportRequest(`${urlApi}/aulas/praticas/carga-horaria/${this.aluno}?schema=${this.schema}`, 'dataPDF', 'relatorio-carga-horaria-pratica-por-aluno')
		},
		async generatePracticalClassesReportPerStudent() {
			await this.reportRequest(`${urlApi}/alunos/pdf/aulas/praticas/${this.aluno}?schema=${this.schema}`, 'dados', 'relatorio-aulas-praticas-por-aluno')
		},
		async handleSubmitPeriod() {
			if (this.validateInputsPeriod()) {
				switch (this.relatorioPeriodo) {
					case 'listaDeAlunos':
						await this.generateStudentListReport()
						break
					case 'aulasPraticasRealizadas':
						await this.generatePracticesCarriedOutReport()
						break
					default:
						this.toast('Tipo do relatório é inválido.')
						break
				}
			}
		},
		validateInputsPeriod() {
			if (!this.relatorioPeriodo || !this.dataIni || !this.dataFim) {
				this.toast('Preencha todos os campos para gerar o relatório.')
				return false
			}

			const dataIni = new Date(this.dataIni)
			const dataFim = new Date(this.dataFim)

			if (dataIni > dataFim) {
				this.toast('A data inicial deve ser menor ou igual à data final.')
				return false
			}

			if (dataFim < dataIni) {
				this.toast('A data final deve ser maior ou igual à data inicial.')
				return false
			}

			return true
		},
		async generateStudentListReport() {
			await this.reportRequest(`${urlApi}/alunos/relatorio-lista-alunos-por-periodo/${this.dataIni}/${this.dataFim}?schema=${this.schema}`, 'dataPDF', 'relatorio-lista-de-alunos-por-periodo')
		},
		async generatePracticesCarriedOutReport() {
			await this.reportRequest(`${urlApiV2}/dashboard/aulas/praticas/realizadas?inicio=${this.dataIni}&fim=${this.dataFim}&schema=${this.schema}`, 'dataPDF', 'relatorio-aulas-praticas-realizadas-por-periodo')
		},
		async reportRequest(url, returnData, filename) {
			this.loading = true

			await this.$http.get(url)
				.then(response => {
					_export.downloadPDF(response.body[returnData], filename)
				})
				.catch(err => {
					this.toast('Erro ao gerar relatório.')
				})
				.finally(() => {
					this.loading = false
				})
		},
		toast(text) {
			this.$toasted.show(text, {
				icon: 'fa-times',
				position: 'top-right',
				duration: 5000,
				fullWidth: false
			})
		},
	},
	watch: {
		schema: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.aluno = null

					this.loadAlunos(newVal)
				}
			},
			deep: true
		}
	},
}
</script>

<style lang="scss" scoped>
.schema-container {
	display: flex;
	flex-direction: column;
	gap: 1rem;

	span {
		font-size: 1rem;
		font-weight: 600;
		line-height: 21.82px;
		color: #606264;
	}
}

.form-container {
	display: flex;
	flex-direction: column;
	gap: 2.5rem;

	.form-container-row {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-end;
		gap: 2.5rem;

		div:first-child {
			max-width: 38.0625rem;
			flex: 1;
		}

		.form-radio {
			display: flex;
			flex-direction: column;
			gap: 1rem;

			span {
				font-size: 1rem;
				font-weight: 600;
				line-height: 21.82px;
				color: #606264;
			}
		}
	}
}
</style>
